<template>
  <button
    type="button"
    class="bg-background-fg/5 flex items-center justify-center rounded-full p-1"
  >
    <IconHeroiconsSolidChevronLeft
      class="text-background-fg/70 h-4 w-4"
    />
  </button>
</template>

<script setup lang="ts"></script>
